(() => {
  function defineProductModal() {
    if (customElements.get('product-modal') || typeof ModalDialog === 'undefined') return false;

    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        this.ensureMediaContent();
        super.show(opener);
        this.showActiveMedia();
      }

      ensureMediaContent() {
        if (this.dataset.mediaLoaded === 'true') return;

        const template = this.querySelector('template[data-product-media-modal-content]');
        if (!template) return;

        this.appendChild(template.content.cloneNode(true));
        this.dataset.mediaLoaded = 'true';
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });

    return true;
  }

  if (!defineProductModal()) {
    document.addEventListener('DOMContentLoaded', defineProductModal, { once: true });
    window.addEventListener('load', defineProductModal, { once: true });
  }
})();
